if (!customElements.get('article-close')) {
  class ArticleClose extends HTMLElement {
    constructor() {
      super();
    }

    handleClick(event) {
      event.preventDefault();

      document.dispatchEvent(new CustomEvent('article-modal:close'));
    }

    connectedCallback() {
      this.addEventListener('click', this.handleClick.bind(this));
    }
  }

  customElements.define('article-close', ArticleClose);
}
